import React, { useState, useContext } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Appbar, Card, Title, Paragraph, TextInput, Button } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import { useToast } from 'react-native-toast-notifications';
import { gql, useMutation } from '@apollo/client';
import { AuthContext } from '../../context/AuthContext';

const REQUEST_ACCOUNT_DELETION = gql`
  mutation RequestAccountDeletion($reason: String) {
    requestAccountDeletion(reason: $reason) {
      id
    }
  }
`;

const DeleteAccountScreen = () => {
  const navigation = useNavigation();
  const toast = useToast();
  const { authState } = useContext(AuthContext);
  const [reason, setReason] = useState('');

  const [requestAccountDeletion, { loading }] = useMutation(REQUEST_ACCOUNT_DELETION, {
    onCompleted: () => {
      toast.show('Votre demande de suppression de compte a bien été envoyée. Un administrateur la traitera dans les plus brefs délais.', { type: 'success' });
      navigation.goBack();
    },
    onError: (error) => {
      toast.show(error.message, { type: 'danger' });
    },
  });

  const handleSubmit = async () => {
    await requestAccountDeletion({ variables: { reason } });
  };

  return (
    <>
      <Appbar.Header>
        <Appbar.BackAction onPress={() => navigation.goBack()} />
        <Appbar.Content title="Supprimer mon compte" />
      </Appbar.Header>
      <ScrollView style={styles.container}>
        <Card style={styles.card}>
          <Card.Content>
            <Title style={styles.title}>Demande de suppression de compte</Title>
            <Paragraph style={styles.paragraph}>
              Vous êtes sur le point de demander la suppression de votre compte <Title>{authState.email}</Title>.
            </Paragraph>
            <Paragraph style={styles.paragraph}>
              Conformément au RGPD, vous pouvez demander la suppression de votre compte et de toutes les données qui y sont associées. La suppression de votre compte est irréversible.
            </Paragraph>
            <Paragraph style={styles.paragraph}>
              Votre demande sera traitée par un administrateur dans les plus brefs délais.
            </Paragraph>

            <View style={styles.form}>
              <TextInput
                label="Raison de la suppression (optionnel)"
                value={reason}
                onChangeText={setReason}
                style={styles.input}
                multiline
                numberOfLines={4}
              />

              <Button
                mode="contained"
                onPress={handleSubmit}
                style={styles.button}
                color="red"
                disabled={loading}
              >
                Envoyer la demande de suppression
              </Button>
            </View>
          </Card.Content>
        </Card>
      </ScrollView>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  card: {
    margin: 16,
  },
  title: {
    fontSize: 24,
    marginBottom: 16,
  },
  paragraph: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'justify',
    marginBottom: 10,
  },
  form: {
    marginTop: 20,
  },
  input: {
    marginBottom: 10,
  },
  button: {
    marginTop: 20,
  },
});

export default DeleteAccountScreen;
